import ColorSchemesExample from "../../gear/navbar/BasicExample.js";
import BlinkingImage from "../../gear/music/Blinker"
import React from 'react';
import logo from "./icon.png";
import cd from "./spinningcd.gif";
import "./index.css"

import audioSrc from "../../gear/music/Voices.mp3"
function DrawLambda() {
    return (
        <div className="justify-content-center" style={{ marginTop: '10%' }}>
            <div>
                <div className="main">
                    <h1 className="info_text">GATEWAY LAMBDA</h1>
                </div>
                <BlinkingImage audioSrc={audioSrc} imageSrc={logo}/>
                <img src={cd} className="left-small" alt=''/>
            </div>
        </div>
    )
}

let Lambda = () => {
    return (
        <div className="container">
            <ColorSchemesExample />
            <DrawLambda />
        </div>
    );
}

export default Lambda;